import styled from 'styled-components';
import { baseVariables } from '@marriott/mi-ui-library';
import { mediaQuery } from '../../../utils';

export const StyledHeroBannerVideo = styled.div`
  &.hb__video-component {
    &.mobile-ratio-1x1 {
      @media ${mediaQuery.mobile} {
        .hb__video {
          height: 100vw;
          .video-js {
            padding-top: 0;
            height: 100vw;
          }
        }
      }
    }
  }
  .hb__video {
    height: 56.25vw;
    .video-js {
      height: 56.25vw;
      [class*='icon-']::before {
        font-family: 'VideoJS';
        color: ${baseVariables.color['base20']};
      }
      .vjs {
        &-dock-text {
          display: none;
        }
        &-control-bar {
          font-size: ${baseVariables.font['fontXs']};
          .vjs-current-time,
          .vjs-time-divider,
          .vjs-duration {
            display: flex;
          }
        }
        &-poster {
          background-position: center;
          background-repeat: no-repeat;
          background-size: cover;
        }
        &-progress-control {
          height: 0.5em;
          top: -0.5em;
        }
        &-play-progress {
          background-color: ${baseVariables.color['base20']};
        }
        &-next-button {
          display: none;
        }
        &-tech {
          object-fit: cover;
        }
        &-volume-level {
          background-color: ${baseVariables.color['base20']};
        }
        &-subs-caps-button,
        &-audio-button {
          display: block !important;
        }
      }

      .vjs-subs-caps-button .vjs-menu .vjs-menu-content .vjs-menu-item .vjs-subtitles-menu-item,
      .vjs-menu-button-popup .vjs-menu .vjs-menu-item.vjs-selected,
      .vjs-subs-caps-button .vjs-menu .vjs-menu-content .vjs-menu-item .vjs-subtitles-menu-item:hover,
      .vjs-menu-button-popup .vjs-menu .vjs-menu-item.vjs-selected:hover {
        background-color: ${baseVariables.color['base20']};
        color: ${baseVariables.color['base10']};
      }

      .vjs-big-play-button,
      .vjs-loading-spinner,
      .vjs-error-display.vjs-modal-dialog {
        display: none;
      }
    }
    &.hero-3x1 {
      @media ${baseVariables.mediaQuery.sm} {
        height: 33.33vw;
        .video-js {
          height: 33.33vw;
          padding-top: 0;
        }
      }
    }
    &.hero-2x1 {
      @media ${baseVariables.mediaQuery.sm} {
        height: 50vw;
        .video-js {
          height: 50vw;
          padding-top: 0;
        }
      }
    }
  }
`;
